module.exports = __webpack_public_path__ + "media/bootstrap-icons/hourglass-bc7766f1.svg";